<template>
    <div id="account-gender">
      <f7-list form class="form-group">
        <f7-list-input
          input-id     ="gender"
          id           ="genderInput"
          name         ="gender"
          class        ="clickable-row use-chevron"
          :label       ="$t('regis-gender')"
          :placeholder ="$t('regis-gender')"
          :value       ="updateDetails.gender == 'M' ? $t('regis-male') : (updateDetails.gender == 'F' ? $t('regis-female') : '')"
          outline
          floating-label
        >
          <f7-link popover-open=".popover-dropdown-1" slot="content-start" class="clickable-item"></f7-link>
        </f7-list-input>
        <f7-popover id="dropdownGender" class="popover-dropdown-1 dropdown-default dropdown account" :backdrop="true">
          <f7-list>
              <f7-list-item popover-close link="#" @click="setUpdateGender('M');validateInput({id: 'gender'});validateNextButton()">{{$t('regis-male')}}</f7-list-item>
              <f7-list-item popover-close link="#" @click="setUpdateGender('F');validateInput({id: 'gender'});validateNextButton()">{{$t('regis-female')}}</f7-list-item>
          </f7-list>
        </f7-popover>

    </f7-list>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      countryList: Array
    },
    mounted (){
      this.init()
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('customer', [
          'updateDetails'
      ])
    },
    methods: {
      ...mapActions('customer', [
          'setUpdateGender',
          'validateInput',
      ]),

      async init(){
          const self    = this;
          const popover = ".account.popover-dropdown-1";
          const popoverInner = ".account.popover-dropdown-1 .popover-inner";
          const popoverId = "dropdownGender";
          const inputId = "gender";
          const inputListId = "#genderInput";
          await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }

    }
  }
</script>